var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.6435 9.48844C19.6435 9.55644 19.1105 16.2972 18.8061 19.1341C18.6155 20.875 17.4932 21.931 15.8097 21.961C14.5162 21.99 13.2499 22 12.0041 22C10.6814 22 9.3879 21.99 8.13233 21.961C6.50525 21.922 5.38196 20.845 5.20106 19.1341C4.8879 16.2872 4.36467 9.55644 4.35494 9.48844C4.34522 9.28345 4.41135 9.08846 4.54556 8.93046C4.67783 8.78447 4.86845 8.69647 5.06879 8.69647H18.9393C19.1387 8.69647 19.3196 8.78447 19.4626 8.93046C19.5958 9.08846 19.6629 9.28345 19.6435 9.48844Z",
    fill: "#5C58FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z",
    fill: "#5C58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.613814e8ecc2e1c26b1be2e953466feb.svg";
export { ForwardRef as ReactComponent };